import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const warehouseApi = {
    adjustCaseAndUnitNums: async (sendParams) => {
        const url = `api/warehouse/v1/cases/adjust`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    updatePalletStatus: async (id, status) => {
        const url = `api/warehouse/v2/pallets/${id}/status`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({
                status,
            }),
        });
    },
    updateLotQCStatus: async (lotId, status) => {
        const url = `api/warehouse/v1/cases/updateAllCasesInLot/${lotId}?status=${status}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({
                status,
            }),
        });
    },
    createReplenishmentChildLocation: async ({ lineNumber, parentLocationId }) => {
        const url = `api/warehouse/v2/locations/create-replenishment-child`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ parentLocationId, lineNumber }),
        });
    },
    createSingleLocation: async (item) => {
        const url = `api/warehouse/v2/locations/create`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
    },
    cacheLocationsToCreate: async (sendParams) => {
        const formData = new FormData();
        for (const key in sendParams) {
            formData.append(key, sendParams[key]);
        }

        const url = `api/warehouse/v2/locations/cache`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
    },
    createPrepLocationGroup: async (item) => {
        const url = `api/warehouse/v2/locations/create-prep`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
    },
    getInternalTransfers: async () => {
        const url = `api/warehouse/v1/internalTransfer`;
        return mmFetchWithResponse(url);
    },
    getInternalTransferInventory: async (facilityID) => {
        const url = `api/warehouse/v1/internalTransfer/pendingInventory?facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    getInventoryHistory: async (params) => {
        const queryParams = `?${new URLSearchParams(params).toString()}`;
        const url = `api/inventory/v1/ims/history${queryParams}`;
        return mmFetchWithResponse(url);
    },
    getItemMaster: async (activeFlag = true, mmOnly = true) => {
        let url = `api/warehouse/v1/itemMaster?active=${activeFlag}`;
        if (mmOnly === false) {
            url += `&mmOnly=false`;
        }
        return mmFetchWithResponse(url);
    },
    getItemMasterDetails: async (itemMasterSKU) => {
        const url = `api/warehouse/v1/itemMaster?intSku=${itemMasterSKU}`;
        return mmFetchWithResponse(url);
    },
    createInternalTransferASN: async (sendParams) => {
        const url = `api/warehouse/v1/internalTransfer/asn`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
    },
    importLoadsheet: async (packGroupID, data) => {
        const url = `api/warehouse/v1/loadsheet/${packGroupID}`;
        const formData = new FormData();
        formData.append('file', data.file);

        return mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
    },
    confirmLoadsheetImport: async (key) => {
        const url = 'api/warehouse/v1/loadsheets/confirm';

        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ key }),
        });
    },
    downloadLoadsheet: async (week, year, facilityID) => {
        const url = `api/warehouse/v1/loadsheet/download?facilityID=${facilityID}&week=${week}&year=${year}`;
        const filename = `loadsheet_results.csv`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadLoadsheet] error', e.toString());
        }
    },
    addItemsToTransferASN: async (poID, items) => {
        const url = `api/warehouse/v1/internalTransfer/asn/${poID}/items`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ items }),
        });
    },
    getLocationsInZone: async (facilityID, zone, zoneType, prefix) => {
        const url = `api/warehouse/v2/locations/zone?facilityID=${facilityID}&zone=${zone}&zoneType=${zoneType}&prefix=${prefix}`;
        return mmFetchWithResponse(url);
    },
    getNewAndExistingLocations: async (item) => {
        const url = `api/warehouse/v2/locations/create/check`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
    },
    confirmLocationCreation: async (key) => {
        const url = 'api/warehouse/v2/locations/confirm';
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ key }),
        });
    },
    bulkDownloadLocationLabels: async (ids) => {
        const filename = 'location_labels.pdf';
        const url = `api/warehouse/v2/locations/labels`;
        try {
            const res = await mmFetch(url, {
                method: 'PUT',
                body: JSON.stringify({ ids }),
            });
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadLocationLabel] error', e.toString());
        }
    },
    downloadScannableRackLabels: async (packGroupID, packGroupYear, packGroupWeek, packGroupName) => {
        const filename = `scannableRackLabels_${packGroupYear}/${packGroupWeek}${packGroupName}.pdf`;
        const url = `api/warehouse/v1/packGroups/${packGroupID}/getScannableRackLabels`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadScannableRackLabels] error', e.toString());
        }
    },
    downloadScannableRackLabelsAdd: async (packGroupID, packGroupYear, packGroupWeek, packGroupName) => {
        const filename = `scannableRackLabels_${packGroupYear}/${packGroupWeek}${packGroupName}_add.pdf`;
        const url = `api/warehouse/v1/packGroups/${packGroupID}/getScannableRackLabelsAdd`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadScannableRackLabelsAdd] error', e.toString());
        }
    },
    downloadScannableRackLabelsRemove: async (packGroupID, packGroupYear, packGroupWeek, packGroupName) => {
        const filename = `scannableRackLabels_${packGroupYear}/${packGroupWeek}${packGroupName}_remove.pdf`;
        const url = `api/warehouse/v1/packGroups/${packGroupID}/getScannableRackLabelsRemove`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadScannableRackLabelsRemove] error', e.toString());
        }
    },
    downloadScannableRackLabelsSlotsChanging: async (packGroupID, packGroupYear, packGroupWeek, packGroupName) => {
        const filename = `scannableRackLabels_${packGroupYear}/${packGroupWeek}${packGroupName}_slots_changing.pdf`;
        const url = `api/warehouse/v1/packGroups/${packGroupID}/getScannableRackLabelsSlotsChanging`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadScannableRackLabelsSlotsChanging] error', e.toString());
        }
    },
    downloadScannableRackLabelsItemsChangingSlots: async (packGroupID, packGroupYear, packGroupWeek, packGroupName) => {
        const filename = `scannableRackLabels_${packGroupYear}/${packGroupWeek}${packGroupName}_items_changing_slots.pdf`;
        const url = `api/warehouse/v1/packGroups/${packGroupID}/getScannableRackLabelsItemsChangingSlots`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadScannableRackLabelsItemsChanginsSlots] error', e.toString());
        }
    },
    downloadSupermarketLabels: async (packGroupID, packGroupYear, packGroupWeek, packGroupName) => {
        const filename = `supermarketLabels_${packGroupYear}/${packGroupWeek}${packGroupName}.pdf`;
        const url = `api/warehouse/v1/packGroups/${packGroupID}/getSupermarketLabels`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadSupermarketLabels] error', e.toString());
        }
    },
    downloadSupermarketLabelsAdd: async (packGroupID, packGroupYear, packGroupWeek, packGroupName) => {
        const filename = `supermarketLabels_${packGroupYear}/${packGroupWeek}${packGroupName}_add.pdf`;
        const url = `api/warehouse/v1/packGroups/${packGroupID}/getSupermarketLabelsAdd`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadSupermarketLabelsAdd] error', e.toString());
        }
    },
    downloadSupermarketLabelsRemove: async (packGroupID, packGroupYear, packGroupWeek, packGroupName) => {
        const filename = `supermarketLabels_${packGroupYear}/${packGroupWeek}${packGroupName}_remove.pdf`;
        const url = `api/warehouse/v1/packGroups/${packGroupID}/getSupermarketLabelsRemove`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadSupermarketLabelsRemove] error', e.toString());
        }
    },
    downloadSupermarketLabelsSlotsChanging: async (packGroupID, packGroupYear, packGroupWeek, packGroupName) => {
        const filename = `supermarketLabels_${packGroupYear}/${packGroupWeek}${packGroupName}_slots_changing.pdf`;
        const url = `api/warehouse/v1/packGroups/${packGroupID}/getSupermarketLabelsSlotsChanging`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadSupermarketLabelsSlotsChanging] error', e.toString());
        }
    },
    downloadSupermarketLabelsItemsChangingSlots: async (packGroupID, packGroupYear, packGroupWeek, packGroupName) => {
        const filename = `supermarketLabels_${packGroupYear}/${packGroupWeek}${packGroupName}_items_changing_slots.pdf`;
        const url = `api/warehouse/v1/packGroups/${packGroupID}/getSupermarketLabelsItemsChangingSlots`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadSupermarketLabelsItemsChanginsSlots] error', e.toString());
        }
    },
    getActiveLocations: async (facilityID) => {
        const url = `api/warehouse/v1/locations?active=true&facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    getFacilities: async (active = false) => {
        let url = `api/warehouse/v1/facilities`;
        if (active) {
            url += '?active=true';
        }
        return mmFetchWithResponse(url);
    },
    getCubeLevels: async () => {
        const url = `api/warehouse/v1/cubeLevels`;
        return mmFetchWithResponse(url);
    },
    getReplenishmentChildLocations: async (facilityId) => {
        const url = `api/warehouse/v1/locations/replenishment-child-locations?facilityId=${facilityId}`;
        return mmFetchWithResponse(url);
    },
    getLocations: async (facilityID, activeOnly = false, inventoryType = undefined, type = undefined) => {
        let url = `api/warehouse/v1/locations?facilityID=${facilityID}`;
        if (activeOnly == true) {
            url += '&active=true';
        }
        if (inventoryType !== undefined) {
            url += `&inventoryType=${inventoryType}`;
        }
        if (type !== undefined) {
            url += `&type=${type}`;
        }
        return mmFetchWithResponse(url);
    },
    getLocationTempZones: async () => {
        const url = `api/warehouse/v1/locations/tempZones`;
        return mmFetchWithResponse(url);
    },
    getLocationTypesV2: async (facilityID) => {
        const url = `api/warehouse/v2/locations/types?facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    getBulkMoveEnabledLocations: async (facilityId) => {
        const url = `api/warehouse/v2/locations/bulk-move-enabled?facilityId=${facilityId}`;
        return mmFetchWithResponse(url);
    },
    getLots: async (activeFlag, facilityID = 0) => {
        let url = `api/warehouse/v1/lots?active=${activeFlag}`;
        if (facilityID > 0) {
            url += `&facilityID=${facilityID}`;
        }
        return mmFetchWithResponse(url);
    },
    getLotsAvailableForTransfer: async (facilityID) => {
        const url = `api/warehouse/v1/internalTransfer/lots?facility=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    getPackaging: async () => {
        const url = `api/warehouse/v1/packaging`;
        return mmFetchWithResponse(url);
    },
    getPackagingLiners: async () => {
        const url = `api/warehouse/v1/packaging/liners`;
        return mmFetchWithResponse(url);
    },
    getPackLines: async (facilityID) => {
        const url = `api/warehouse/v1/packLineSlotMap?facility=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    getPackLineSlotMapByLine: async (lineID) => {
        const url = `api/warehouse/v1/packLineSlotMap?line=${lineID}`;
        return mmFetchWithResponse(url);
    },
    getLoadsheetByWeekYear: async (week, year, facilityID) => {
        const url = `api/warehouse/v1/loadsheet?week=${week}&year=${year}&facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    updateLoadsheet: async (formData) => {
        const url = `api/warehouse/v1/loadsheet`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(formData),
        });
    },
    deleteLoadSheet: async (id) => {
        const url = `api/warehouse/v1/loadsheet/${id}`;
        return mmFetchWithResponse(url, { method: 'DELETE' });
    },
    getPackLinesInFacilityWithLotLoc: async (lotLocID) => {
        const url = `api/warehouse/v1/packLines?lotLocID=${lotLocID}`;
        return mmFetchWithResponse(url);
    },
    getPackLineSlots: async (packLineID) => {
        const url = `api/warehouse/v1/packLines/${packLineID}/slots`;
        return mmFetchWithResponse(url);
    },
    getPackLineZoneConfig: async (packLineID) => {
        const url = `api/warehouse/v1/packLines/${packLineID}/zoneConfig`;
        return mmFetchWithResponse(url);
    },
    hydratePackLineSlotMap: async (packLineID, packGroupID) => {
        const url = `api/warehouse/v1/packLineSlotMap/hydrate`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ packLineID, packGroupID }),
        });
    },
    moveCasesAndLooseUnits: async (sendParams) => {
        // allow split case functionality for desktop only
        if (sendParams) {
            sendParams.allowSplitCase = true;
        }
        const url = `api/warehouse/v1/cases/move`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    markPackLineSlotOOS: async (packLineID, slot, reason) => {
        const url = `api/warehouse/v1/packLineSlotMap`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({
                packLineID,
                slot,
                status: 'OUT_OF_STOCK',
                reason,
            }),
        });
    },
    movePallet: async (id, sendParams) => {
        const url = `api/warehouse/v1/pallets/${id}/move`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    bulkMovePallets: async (palletIds, destinationLocationId) => {
        const url = 'api/warehouse/v2/pallets/bulk/move';
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({
                palletIds,
                destinationLocationId,
            }),
        });
    },
    updateCubeRanges: async (sendParams) => {
        const url = `api/warehouse/v1/cubeLevels`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    updateLocations: async (item) => {
        const url = `api/warehouse/v2/locations/update`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(item),
        });
    },
    updateLot: async (lotID, item) => {
        const url = `api/warehouse/v1/lots/${lotID}/update`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(item),
        });
    },
    updatePackLine: async (packLineID, sendParams) => {
        const url = `api/warehouse/v1/packLines/${packLineID}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    updatePackLineSlotStatus: async (packLineID, slot, status) => {
        const url = `api/warehouse/v1/packLineSlotMap`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({
                packLineID,
                slot,
                status,
            }),
        });
    },
    uploadLoadsheet: async (packGroupID) => {
        const url = `api/warehouse/v1/loadsheet/${packGroupID}/upload`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
        });
    },
    getPackSyncRuns: async (facilityID) => {
        let url = 'api/warehouse/v1/pack-sync-runs';
        url += `?facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    getPackSyncRunsData: async (packSyncRunID) => {
        let url = 'api/warehouse/v1/pack-sync-runs';
        url += `/${packSyncRunID}`;
        return mmFetchWithResponse(url);
    },
    initiatePackSync: async (facilityID) => {
        let url = 'api/warehouse/v1/initiate-pack-sync';
        url += `?facilityID=${facilityID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
        });
    },
    confirmPackSync: async (packSyncRunID) => {
        let url = 'api/warehouse/v1/confirm-pack-sync';
        url += `/${packSyncRunID}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
        });
    },
    cancelPendingPackSync: async (packSyncRunID) => {
        let url = 'api/warehouse/v1/cancel-pending-pack-sync';
        url += `/${packSyncRunID}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
        });
    },
    createAssociatedPackLine: async (id, associatedID) => {
        const body = {};
        body.associatedID = associatedID;
        const url = `api/warehouse/v1/packLines/create-associated-packline/${id}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(body),
        });
    },
    deleteAssociatedPackLine: async (packLineID, associatedID) => {
        const url = `api/warehouse/v1/packLines/delete-associated-packline/${packLineID}/${associatedID}`;
        return mmFetchWithResponse(url, { method: 'DELETE' });
    },
    lotNotInLocation: async (lotId, locationid, locationInventoryType, facilityId) => {
        let url = `api/warehouse/v1/lots/${lotId}/missing/${locationid}`;
        url += `?facilityId=${facilityId}`;
        url += `&locationType=${locationInventoryType}`;
        return mmFetchWithResponse(url, { method: 'POST' });
    },
    palletEmpty: async (palletID, facilityId) => {
        const url = `api/warehouse/v2/pallets/${palletID}/missing?facilityId=${facilityId}`;
        return mmFetchWithResponse(url, { method: 'PUT' });
    },
    locationEmpty: async (locationid, facilityId) => {
        const url = `api/warehouse/v2/locations/missing/${locationid}?facilityId=${facilityId}`;
        return mmFetchWithResponse(url, { method: 'PUT' });
    },
    createNewPalletForLocation: async (locationId) => {
        const url = `api/warehouse/v2/pallets/createEmptyPallet?locationId=${locationId}`;
        return mmFetchWithResponse(url, { method: 'POST' });
    },
    getReceivingCorrectionPreview: async (lotId, numUnits) => {
        const url = `api/inventory-adjustment/v1/receiving-correction/preview?lotId=${lotId}&numUnits=${numUnits}`;
        return mmFetchWithResponse(url);
    },
    bulkAdjustNumUnits: async (sendParams) => {
        const url = `api/inventory-adjustment/v1/receiving-correction/correct`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
    },
    getPackoutRetryPreview: async (facilityId) => {
        const url = `api/warehouse/v1/packout-retry/preview?facilityId=${facilityId}`;
        return mmFetchWithResponse(url);
    },
    runPackoutRetry: async (facilityId) => {
        const url = 'api/warehouse/v1/packout-retry';
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ facilityId }),
        });
    },
};

export { warehouseApi };
